module.exports = __webpack_public_path__ + "img/logo-big.ad796c08.png";